// ============================================================================
// FSA OPENING BALANCE VERIFICATION HOOK  (ADR-0007)
// ============================================================================

import { useCallback, useEffect, useState } from 'react';
import { fsaObVerificationService } from 'api/services/fsa/fsaObVerificationService';
import type { ID } from 'api/types';
import type { ObVerificationWorkspace } from 'api/types/fsa/obVerification.types';

export const useFsaObVerification = (engagementId: ID | null) => {
  const [workspace, setWorkspace] = useState<ObVerificationWorkspace | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchWorkspace = useCallback(async () => {
    if (!engagementId) return;
    setLoading(true);
    setError(null);
    try {
      const r = await fsaObVerificationService.getWorkspace(engagementId);
      setWorkspace(r.data ?? null);
    } catch (err: any) {
      setError(err?.response?.data?.message ?? err?.message ?? 'Failed to load opening balance verification.');
    } finally {
      setLoading(false);
    }
  }, [engagementId]);

  useEffect(() => {
    fetchWorkspace();
  }, [fetchWorkspace]);

  return { workspace, setWorkspace, loading, error, refetch: fetchWorkspace };
};

export default useFsaObVerification;
